module.exports = __webpack_public_path__ + "img/landing-logo-mobile.0064132c.png";